import { makeObservable, observable, action } from "mobx";
import { track } from "@vercel/analytics";
// import LogRocket from "logrocket";
import is from "is";
import { nanoid } from "nanoid";
import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import localStorage from "mobx-localstorage";
import { getDomainFromEmail, numberFromText } from "../utils/helper";

export class StoreMain {
  isLoaded = false;
  isInitialized = false;
  licenseType = "free";
  licenseCheck = false; // activate the element blurring for apps
  trialDaysLeft = 0;
  daysActive = 0;
  limitCellCount = 20000;
  limitElementCount = 25;
  currentElementCount = 0;
  homeMenuIsOpen = window.location.hash.includes("/element")
    ? false
    : this.getLocalStoreValue("homeMenuIsOpen", true);
  homeMenuStyle = this.getLocalStoreValue("homeMenuStyle", "compact");
  asidePanelIsOpen = false;
  asideNotificationPanelIsOpen = false;
  asideHelperPanelIsOpen = false;
  optionsShowHelpIcons = true;
  optionRichtextInlineMode = false;
  optionAllowExternalData = true;
  noUserPhoto = undefined;
  hideHeader = false;
  activeViewCaption = "";
  activeViewType = "";
  activeViewHasSharingInfo = false;
  activeViewOptions = null;
  activeViewHasOfflineData = false;
  activeViewHasNoHeader = false;
  activeElementId = null;
  activeViewHeaderIsVisible =
    window?.location?.hash === "#/home" || !window?.location?.hash;
  activeMainHeaderIsVisible = true;
  activeCookies = {};
  activeChangeTitle = null;
  activeChangeTitleProc = null;
  chartThumbnailSize = this.getLocalStoreValue("chart-thumbnailSize", 500);
  loadingString = ""; //"Loading...";
  // USER
  userPhoto = "";
  userEmail = "";
  userMicrosoftEmail = "";
  userName = "";
  userId = "";
  userMe = undefined;
  userLanguage = "en-US";
  userDomain = "";
  userDomainSettings = null;
  domainTemplates = [];
  domainTemplatesChecked = false;
  userTenantId = "";
  userIsHomeAccount = undefined;
  userHasTeamFolders = false;
  userLinkedInfoLoaded = false;
  userLinkedInfoLoading = false;
  userConfigurations = [];
  userServices = [];
  userHasProLicense = false;
  userScopes = null;
  userMode =
    this.rootStore?.isPhone || this.rootStore?.isTeams
      ? "apps"
      : this.getLocalStoreValue("userMode", "creator");
  authType = null;
  withTracking = false;
  withWistia = true;
  withLiveUpdate = true;
  withHostedFiles = true;
  userHasNewPublicId = false;
  userIsBlocked = false;
  userDataLoaded = false;
  userDataLoading = false;
  isPaymentAreaVisible = false;
  isChangeTitleAreaVisible = false;
  isFilesAreaVisible = false;
  isMicrosoftLogin = false;
  isLoadingInProgress = false;
  elementFullScreen = false;
  s3CustomerConfig = null;
  subscriptionEnd = null;
  subscriptionInfo = null;
  onedrivePickerRetries = 2;
  isKeepReference = this.getLocalStoreValue("isKeepReference", false);
  isTrialAreaVisible = false;

  // Wistia
  videoScriptId = null;

  // form
  formElementMinHeight = 32;
  formFontSizeDefault = 14;

  formElementDefaultStyle = { padding: 0 };

  formElementDefaultMobileStyle = { padding: 0 };

  // LICENSES

  licenseTypes = [
    {
      id: "free",
      index: 0,
      stripeId: "",
      priceMonthYearly: 0,
      priceMonthMonthly: 0,
      limitAppElements: 25,
      name: "Free",
      description:
        "Our free plan lets you create and share apps - with app sharing limited to 25 elements per app. Click here to buy a subscription to create bigger apps.",
      descriptionShort: (
        <div>
          This plan allows you to create and share apps with up to{" "}
          <strong>25 elements</strong>.
        </div>
      ),
    },
    {
      id: "lite",
      index: 1,
      stripeId: "price_1OiazNLs3YHp0rXILnBICcLq",
      stripePaymentLink: "https://buy.stripe.com/5kAaII8XQaice3K3cu", //"https://buy.stripe.com/test_14kdTj7116gb3q83ce",
      stripeYearlyId: "price_1Oib0MLs3YHp0rXIrwPlPv3s",
      stripeYearlyPaymentLink: "https://buy.stripe.com/8wMcQQa1U9e83p67sJ", //"https://buy.stripe.com/test_14kdTj7116gb3q83ce",
      priceMonthYearly: 19,
      priceMonthMonthly: 25,
      limitAppElements: 50,
      name: "Lite",
      description:
        "Unlock the power to create and share dynamic apps, each supporting up to 50 elements for seamless collaboration. Empower your users by enabling them to edit data within your apps for enhanced interaction. For advanced capabilities, including data submission features, upgrade to our PRO Plan.",
      descriptionShort: (
        <div>
          Create unlimited apps with up to <strong>50 elements</strong> and
          share <strong>editable granular spreadsheet areas</strong>.
        </div>
      ),
    },
    {
      id: "pro",
      index: 2,
      stripeId: "price_1Oib8rLs3YHp0rXIbLggiNBW",
      stripePaymentLink: "https://buy.stripe.com/3cscQQ3Dw3TOf7OeVe",
      stripeYearlyId: "price_1Oib9GLs3YHp0rXIe3QYYtOT",
      stripeYearlyPaymentLink: "https://buy.stripe.com/dR6aIIca24XSbVCeVd",
      priceMonthYearly: 49,
      priceMonthMonthly: 59,
      limitAppElements: 100,
      name: "Pro",
      description:
        "Pro plan lets you create and share apps - with app sharing limited to 100 elements per app.",
      descriptionShort: (
        <div>
          Create apps with up to <strong>100 elements</strong> and share
          spreadsheet areas including <strong>change tracking</strong> and{" "}
          <strong>data submissions</strong>.
        </div>
      ),
    },
    {
      id: "premium",
      index: 3,
      stripeId: "price_1OibdmLs3YHp0rXIzdypcxjJ",
      stripePaymentLink: "https://buy.stripe.com/7sI9EE7TM8a41gY28t",
      stripeYearlyId: "price_1OibbVLs3YHp0rXIIZN9YijE",
      stripeYearlyPaymentLink: "https://buy.stripe.com/4gw8AA7TMaic4taaF0", //"https://buy.stripe.com/test_14kdTj7116gb3q83ce",
      priceMonthYearly: 299,
      priceMonthMonthly: 349,
      limitAppElements: 5000,
      name: "Premium",
      description:
        "Premium plan lets you create and share apps - with unlimited elements per app.",
      descriptionShort: (
        <div>
          The premium plan lets you create <strong>unlimited apps</strong> with
          unlimited public users and allows{" "}
          <strong>granular sharing & consolidation</strong>. Usage analytics is
          included.
        </div>
      ),
    },
    {
      id: "partner",
      index: 5,
      stripeId: "price_1MnTakLs3YHp0rXIP8MCSBqs", //price_1MnTfALs3YHp0rXI3EDP2xvG
      stripePaymentLink: "https://buy.stripe.com/dR62cc5LEfCw7Fm4gl",
      priceMonthYearly: 99,
      priceMonthMonthly: 129,
      limitAppElements: 5000,
      name: "Partner",
      description:
        "Partner plan lets you create and share apps - with app sharing limited to 5000 elements per app.",
      descriptionShort: (
        <div>
          This plan allows you to share up to <strong>500 elements</strong> in
          each app.
        </div>
      ),
    },
  ];

  // WINDOW

  windowInfo = {};
  autoWizardShow = false;
  autoWizardStep = null;
  sectionModalOpen = false;

  isMagicAuthAreaVisible = false;

  constructor(rootStore) {
    this.rootStore = rootStore;

    makeObservable(this, {
      isLoaded: observable,
      isInitialized: observable,
      setIsLoaded: action,
      setIsInitialized: action,
      isPaymentAreaVisible: observable,
      isChangeTitleAreaVisible: observable,
      isFilesAreaVisible: observable,
      setPaymentAreaVisible: action,
      setChangeTitleAreaVisible: action,
      setActiveChangeTitle: action,
      setFilesAreaVisible: action,
      loadingString: observable,
      licenseType: observable,
      isLoadingInProgress: observable,
      setIsLoadingInProgress: action,
      userDataLoaded: observable,
      userDataLoading: observable,
      userLinkedInfoLoading: observable,
      userDomainSettings: observable,
      userConfigurations: observable,
      userServices: observable,
      setUserDomainSettings: action,
      setUserLinkedInfoNeedsLoading: action,
      setUserDataLoading: action,
      setUserDataLoaded: action,
      userMode: observable,
      setUserMode: action,
      homeMenuIsOpen: observable,
      homeMenuStyle: observable,
      asidePanelIsOpen: observable,
      asideNotificationPanelIsOpen: observable,
      asideHelperPanelIsOpen: observable,
      activeViewHeaderIsVisible: observable,
      activeViewHasSharingInfo: observable,
      activeViewCaption: observable,
      activeViewType: observable,
      activeViewOptions: observable,
      setActiveViewOptions: action,
      activeViewHasOfflineData: observable,
      activeChangeTitle: observable,
      activeElementId: observable,
      windowInfo: observable,
      elementFullScreen: observable,
      onedrivePickerRetries: observable,
      domainTemplates: observable,
      setDomainTemplates: action,
      setOneDriveRetries: action,
      toggleElementFullScreen: action,
      setViewBackgroundImage: action,
      setActiveViewHeaderIsVisible: action,
      setActiveViewHasSharingInfo: action,
      setActiveViewHasOfflineData: action,
      setActiveViewCaption: action,
      setActiveViewType: action,
      setActiveElementId: action,
      setLoadingString: action,
      setWindowInfo: action,
      toggleHomeMenu: action,
      toggleHomeMenuStyle: action,
      toggleAsidePanel: action,
      toggleNotificationAsidePanel: action,
      toggleHelperAsidePanel: action,
      setUserProperties: action,
      setUserLanguage: action,
      videoScriptId: observable,
      s3CustomerConfig: observable,
      setS3CustomerConfig: action,
      currentElementCount: observable,
      setCurrentElementCount: action,
      withHostedFiles: observable,
      autoWizardShow: observable,
      autoWizardStep: observable,
      showAutoWizardModal: action,
      hideAutoWizardModal: action,
      sectionModalOpen: observable,
      setSectionModalOpen: action,
      isKeepReference: observable,
      setIsKeepReference: action,
      isTrialAreaVisible: observable,
      isMagicAuthAreaVisible: observable,
      setMagicAuthAreaVisible: action,
    });
  }

  setAutoWizardStep(step) {
    this.autoWizardStep = step;
  }

  showAutoWizardModal(step) {
    this.autoWizardShow = true;
    this.autoWizardStep = step;
  }

  hideAutoWizardModal() {
    this.autoWizardShow = false;
    this.autoWizardStep = null;
  }

  setHideHeader(status) {
    this.hideHeader = status;
  }

  setIsKeepReference(status) {
    this.isKeepReference = status;
    this.setLocalStoreValue("isKeepReference", status);
  }

  setIsLoadingInProgress(status) {
    this.isLoadingInProgress = status;
  }

  setSectionModalOpen(status) {
    this.sectionModalOpen = status;
  }

  setCurrentElementCount(length) {
    this.currentElementCount = length;
  }

  getNearInLimitationCount() {
    const limitLength = this.limitElementCount;
    let nearIn = 5;
    if (limitLength / 25 >= 2) {
      nearIn = 10;
    }
    if (limitLength / 100 >= 2) {
      nearIn = 20;
    }
    if (limitLength / 500 >= 2) {
      nearIn = 50;
    }
    return nearIn;
  }

  isFeatureDisabled(neededVersion) {
    if (
      !neededVersion ||
      !this.licenseType ||
      ["premium", "partner", "enterprise"].includes(this.licenseType)
    )
      return false;

    const actualLicense = this.licenseType;
    let isDisabled = false;

    if (neededVersion === "lite") {
      isDisabled = actualLicense === "free";
    }
    if (neededVersion === "pro") {
      isDisabled = ["free", "lite"].includes(actualLicense);
    }
    if (neededVersion === "premium") {
      isDisabled = true;
    }
    if (neededVersion === "enterprise") {
      isDisabled = true;
    }
    return isDisabled;
  }

  toggleHomeMenu(visible) {
    // no hidden menu in Teams
    if (this.rootStore?.isTeams && !visible) return;

    if (visible === undefined) {
      this.homeMenuIsOpen = !this.homeMenuIsOpen;
    } else {
      this.homeMenuIsOpen = visible;
    }
  }

  toggleHomeMenuStyle(style) {
    let newStyle = style
      ? style
      : this.homeMenuStyle === "large"
        ? "compact"
        : "large";
    this.homeMenuStyle = newStyle;
    this.setLocalStoreValue("homeMenuStyle", newStyle);
  }

  toggleAsidePanel(visible) {
    if (visible === undefined) {
      this.asidePanelIsOpen = !this.asidePanelIsOpen;
    } else {
      this.asidePanelIsOpen = visible;
    }
  }

  toggleNotificationAsidePanel(visible) {
    if (visible === undefined) {
      this.asideNotificationPanelIsOpen = !this.asideNotificationPanelIsOpen;
    } else {
      this.asideNotificationPanelIsOpen = visible;
    }
    this.rootStore.sharing.setNotificationMarker(false);
  }

  toggleHelperAsidePanel(visible) {
    if (visible === undefined) {
      this.asideHelperPanelIsOpen = !this.asideHelperPanelIsOpen;
    } else {
      this.asideHelperPanelIsOpen = visible;
    }
  }

  toggleElementFullScreen(value) {
    if (value === undefined) {
      this.elementFullScreen = !this.elementFullScreen;
    } else {
      this.elementFullScreen = value;
    }
  }

  translateText(text) {
    if (text === "loading element...") {
      if (this.userLanguage === "de-DE") {
        return "Laden...";
      } else {
        return text;
      }
    }
    if (text === "Loading element") {
      if (this.userLanguage === "de-DE") {
        return "Element wird geladen";
      } else {
        return text;
      }
    }
    if (text === "Loading logic...") {
      if (this.userLanguage === "de-DE") {
        return "Lade Berechnungslogik...";
      } else {
        return text;
      }
    }

    if (text === "Filter this list") {
      if (this.userLanguage === "de-DE") {
        return "Einträge filtern";
      } else {
        return "Filter items";
      }
    }
    if (text === "Enter a good title") {
      if (this.userLanguage === "de-DE") {
        return "Bezeichnung eingeben";
      } else {
        return "Enter a good title";
      }
    }
    return text;
  }

  getLicenseDescription(subscriptionPlan) {
    let targetPlan = this.licenseTypes.find((x) => x.id === subscriptionPlan);
    if (targetPlan?.description) return targetPlan.description;

    return "Our free plan lets you create and share unlimited apps with unlimited people, with app sharing limited to 25 elements per app.";
  }

  getLicenseIndex(subscriptionPlan = this.licenseType) {
    let targetPlan = this.licenseTypes.find((x) => x.id === subscriptionPlan);
    if (targetPlan?.index) return targetPlan.index;

    return 0;
  }

  getLicenseInformation(subscriptionPlan) {
    let targetPlan = this.licenseTypes.find((x) => x.id === subscriptionPlan);
    return targetPlan;
  }

  getUserEmailOrId() {
    let userEmail = this.userEmail;
    if (!userEmail) userEmail = this.userMicrosoftEmail;
    if (!userEmail) userEmail = this.userId;
    if (!userEmail) userEmail = this.getPublicUserId();
    return userEmail;
  }

  getUserPublicPageUrl() {
    const userId = this.userEmail ?? this.getPublicUserId();
    return "https://app.airrange.io/#/page/" + userId;
  }

  async getUserLinkedInfo(refresh = false) {
    if (
      this.userLinkedInfoLoaded === true &&
      // this.userLinkedInfoLoading === true &&
      refresh === false
    )
      return;

    this.userLinkedInfoLoading = true;
    try {
      await this.rootStore.appsync.getUserLinkedInfo();
    } finally {
      this.userLinkedInfoLoaded = true;
      this.userLinkedInfoLoading = false;
    }
  }

  async getUserConfigurations() {
    // get user configurations
    this.rootStore.appsync
      .getUserConfigurations(
        this.userEmail,
        "calculation",
        false, // refresh
      )
      .then((data) => {
        this.userConfigurations = data?.configurations ?? [];
        this.userServices = data?.services ?? [];
      });
  }

  getHostUrl() {
    return "https://app.airrange.io/#";
    // return window.location.host + "/#";
  }

  getLocalStoreValue(name, defaultValue) {
    let tempValue = localStorage.getItem(name);
    if (tempValue === false) {
      return false;
    } else {
      return tempValue ? tempValue : defaultValue;
    }
  }

  setLocalStoreValue(name, actualValue) {
    try {
      if (is.array(actualValue)) {
        if (is.array.empty(actualValue)) {
          //remove entry
          localStorage.removeItem(name);
          return;
        }
      }
      if (actualValue === "" || actualValue === null) {
        //remove entry
        localStorage.removeItem(name);
        return;
      }
      localStorage.setItem(name, actualValue);
    } catch (e) {
      console.log("ERROR setLocalStoreValue", e);
    }
  }

  removeLocalStoreValue(name) {
    localStorage.removeItem(name);
  }

  setActiveViewHasOfflineData(value) {
    this.activeViewHasOfflineData = value;
  }

  setUserProperties(
    maxElements,
    licenseType,
    validUntil,
    trialDaysLeft,
    withLiveUpdate,
    preferredLanguage,
    subscriptionInfo,
    authType,
    daysActive,
  ) {
    this.limitElementCount = maxElements;
    this.limitCellCount = 20000;
    this.licenseType = licenseType;
    this.userHasProLicense = licenseType !== "free" && licenseType !== "lite";
    this.trialDaysLeft = trialDaysLeft;
    if (trialDaysLeft < 1) this.licenseCheck = true;
    this.withLiveUpdate = withLiveUpdate;
    this.subscriptionEnd = validUntil;
    this.subscriptionInfo = subscriptionInfo;
    this.userLanguage = preferredLanguage ?? "en-US";
    this.authType = authType;
    this.daysActive = Math.abs(daysActive);
    this.isInitialized = true;
  }

  setUserScopes(scopes) {
    this.userScopes = scopes;
  }

  setUserDataLoaded(status) {
    this.userDataLoaded = status;
  }

  setUserDataLoading(status) {
    this.userDataLoading = status;
  }

  setUserLinkedInfoNeedsLoading() {
    this.userLinkedInfoLoaded = false;
  }

  setNoUserPhoto(noUserPhoto) {
    this.noUserPhoto = noUserPhoto;
  }

  setUserTenantId(tenantId) {
    this.userTenantId = tenantId;
    this.userIsHomeAccount =
      tenantId === "9188040d-6c67-4c5b-b112-36a304b66dad";
    this.userHasTeamFolders = !this.userIsHomeAccount;
  }

  setUserId(userId) {
    this.userId = userId;
  }

  setMicrosoftUser(userMe) {
    this.userMe = userMe;
    this.userMicrosoftEmail = userMe?.mail?.toLowerCase();
    this.userEmail = userMe?.mail?.toLowerCase() ?? userMe?.userPrincipalName;
    this.userName = userMe?.displayName;
    this.userId = userMe?.id;
    // track
    this.withTracking &&
      track("user-login", {
        type: "microsoft",
      });

    // this.userLanguage = userLanguage;
    // this.userLanguage = "en-US";
    this.userDomain = getDomainFromEmail(userMe?.mail);
    this.userIsBlocked = false;
    this.isMicrosoftLogin = true;
    // get the recents for this user
    this.rootStore.workbooks.getRecentDocuments();
  }

  setEmailUser(user) {
    if (!user) return;

    this.userMe = null;
    this.userMicrosoftEmail = "";
    this.userEmail = user.email;
    this.userName = user.email;
    this.userId = user.id;
    // this.userLanguage = userLanguage;
    // this.userLanguage = "en-US";
    this.userDomain = getDomainFromEmail(user.email);
    this.userIsBlocked = false;
    this.isMicrosoftLogin = false;
    // get the recents for this user
    this.rootStore.workbooks.getRecentDocuments();
  }

  setUserDomainSettings(info) {
    this.userDomainSettings = info;
    // set domain options
    this.withHostedFiles = true; // info?.allowHostedFiles ?? this.rootStore.isDebug;
  }

  setUserMode(mode) {
    this.userMode = mode;
    this.setLocalStoreValue("userMode", mode);
  }

  setDomainTemplates(templates) {
    this.domainTemplates = templates;
  }

  async checkDomainTemplates(reload = false, callback) {
    let list;
    if (
      reload ||
      (this.domainTemplates.length === 0 && !this.domainTemplatesChecked)
    ) {
      list = await this.rootStore.appsync.getDomainTemplates();
      if (list && list.length > 0) this.setDomainTemplates(list);
      this.domainTemplatesChecked = true;
    }
    if (callback) callback(list ?? this.domainTemplates);
  }

  getUserPhoto() {
    let photo = this.getLocalStoreValue("userPhoto", null);
    this.userPhoto = photo;
    return photo;
  }

  setUserPhoto(photo) {
    if (!photo) return;

    try {
      let reader = new FileReader();
      reader.readAsDataURL(photo);
      reader.onload = () => this.afterSetUserPhoto(reader.result);
    } catch (error) {
      console.log("ERROR setUserPhoto", error);
    }
  }
  afterSetUserPhoto(photoString) {
    if (!photoString) return;
    this.setLocalStoreValue("userPhoto", photoString);
    this.userPhoto = photoString;
  }

  async setUserLanguage(value) {
    if (!value) return;

    this.userLanguage = value;
    // update in aws
    if (this.userEmail?.length > 5) {
      await this.rootStore.appsync.updateUserPreferredLanguage(value);
    }
    // update in local storage
    this.setLocalStoreValue("userLanguage", value);
  }

  setUserInfo(user) {
    let userId = user ? user.id : this.userId;
    // is it a local user
    if (!userId) userId = this.getPublicUserId();
    let publicId = this.getLocalStoreValue("publicUserId");
    // const userFullname = user && user.displayName ? user.displayName : "Public";
    let userEmail = user ? user.email : "public@airrange.io";
    if (!userEmail) userEmail = "";
    if (user && this.userDomain) user.userDomain = this.userDomain;

    // ================================================
    // TRACKING
    // ================================================
    try {
      let withTracking = !this.isDebug; // && (userEmail.length > 0 || userId.length > 0);
      if (withTracking) {
        track("user-info", {
          debug: false,
          publicId: publicId,
          email: userEmail,
          domain: this.userDomain,
          authType: this.authType,
          plan: this.licenseType,
          isTeams: this.rootStore.isTeams,
          isIncognitoBrowser: this.rootStore.isIncognitoBrowser,
        });
      }

      this.withTracking = withTracking;
    } catch (err) {
      console.log("ERROR initializing analytics", err);
    }

    // ================================================
    // LogRocket logging
    // ================================================
    // if (
    //   this.rootStore.isDebug === false &&
    //   !userEmail.includes("stephan@airrange.io")
    // ) {
    //   const info = {
    //     publicId: publicId,
    //     name: userFullname,
    //     email: userEmail,
    //     userDomain: this.userDomain,
    //     ms_scopes: this.rootStore.microsoftAccessToken?.scopes,
    //     is_debug: this.rootStore.isDebug,
    //   };
    //   this.initializeLogRocket(userId, info);
    // }

    // ================================================
    // Progressier networking
    // ================================================
    // window.addEventListener("load", function(){
    //   progressier.add({
    //     id: publicId,
    //     email: userEmail,
    //     userDomain: userDomain,
    //   });
    // });
    // } catch (err) {
    //   console.log("ERROR initializing logrocket", err);
    // }
  }

  // async initializeLogRocket(userId, info) {
  //   try {
  //     LogRocket.init("rgptae/airrange-web");
  //     LogRocket.identify(userId, info);
  //   } catch (err) {
  //     console.log("ERROR initializing logrocket", err);
  //   }
  // }

  createPublicUserId() {
    const url = window?.location?.hash ?? "";
    const isEmbeddedOnSafari = this.rootStore.isEmbedded === true; // && this.rootStore.isSafari === true;
    let userId;

    if (isEmbeddedOnSafari) {
      // we are embedded
      try {
        getCurrentBrowserFingerPrint().then((result) => {
          if (result) {
            userId = "fingerprint-" + result?.toString();
          } else {
            userId = "public-" + nanoid();
          }
          userId = userId?.toLowerCase();
          console.log("INFO create new publicUserId in embedded mode", userId);
          this.setLocalStoreValue("publicUserId", userId);
          this.userHasNewPublicId = true;
          return userId;
        });
      } catch (error) {
        console.log("ERROR createPublicUserId", error);
      }
    }

    if (!isEmbeddedOnSafari) {
      userId = "public-" + nanoid();
      userId = userId.toLowerCase();
      console.log("INFO create new publicUserId", userId);

      this.setLocalStoreValue("publicUserId", userId);
      this.userHasNewPublicId = true;
      // inform the server about a new user
      try {
        // log it to aws
        let publicUserData = {
          cookies: this.activeCookies,
          isIncognitoBrowser: this.rootStore.isIncognitoBrowser,
          isDebug: this.rootStore.isDebug,
          url: url,
          deviceInfo: this.rootStore.activeDevice,
        };
        this.rootStore.appsync.logPublicUser(userId, publicUserData);
      } catch (error) {
        console.log("ERROR createPublicUserId", error);
      } finally {
        setTimeout(() => {
          // track
          track("user-public-create", {
            userId: userId,
            incognitoBrowser: this.rootStore.isIncognitoBrowser,
          });
        }, 200);
      }

      return userId;
    }
  }

  trackEvent(eventName, eventType) {
    if (this.rootStore.isDebug) return;

    // track
    this.withTracking &&
      track(eventName, {
        type: eventType,
      });
  }

  getPublicUserId() {
    // let userId = this.userEmail?.length > 0 ? this.userEmail : this.userId;
    // if (userId) userId = userId.toLowerCase();
    let userId = this.getLocalStoreValue("publicUserId");
    userId = userId?.toLowerCase();
    if (!userId || userId.length < 5) userId = this.createPublicUserId();

    return userId;
  }

  setPublicUserId(userId) {
    if (!userId) return;
    this.setLocalStoreValue("publicUserId", userId);
    this.setUserId(userId);
  }

  getUserColor(email) {
    if (email === "undefined" || !email)
      return this.rootStore.colors.colorAccent;

    return this.rootStore.colors.colorAvatars[
      numberFromText(email) % this.rootStore.colors.colorAvatars.length
    ];
  }

  isUserEmailExternal(email) {
    const userDomain = getDomainFromEmail(email);
    return userDomain !== this.userDomain;
  }

  isUserRegistered() {
    return this.userEmail?.length > 0;
  }

  setWindowInfo(windowSize, detailPaneIsVisible) {
    if (windowSize) {
      this.windowInfo.size = windowSize;
    }
    if (detailPaneIsVisible) {
      this.windowInfo.detailPaneIsVisible = detailPaneIsVisible;
    }
  }

  setLoadingString(info) {
    this.loadingString = info || ""; //"Loading...";
  }

  setActiveViewHeaderIsVisible(visible) {
    this.activeViewHeaderIsVisible = visible;
  }

  setActiveViewCaption(caption) {
    this.activeViewCaption = caption ?? "";
  }

  setActiveViewOptions(options) {
    this.activeViewOptions = options;
  }

  setActiveViewHasSharingInfo(value) {
    this.activeViewHasSharingInfo = value;
  }

  setActiveViewType(viewType) {
    this.activeViewType = viewType;
  }

  setActiveElementId(elementId) {
    let activeElementId = elementId?.replace("{", "").replace("}", "");
    this.activeElementId = activeElementId;
  }

  getMainMenuIconColor(state) {
    const colorActive = this.rootStore.colors.colorMainText;
    const colorIcon = this.rootStore.colors.colorGreyText;
    return this.activeViewType === state ? colorActive : colorIcon;
  }

  setViewInfo(viewInfo) {
    if (!viewInfo) return;

    viewInfo.headerIsVisible != null &&
      this.setActiveViewHeaderIsVisible(viewInfo.headerIsVisible);
    this.setActiveViewCaption(viewInfo.headerCaption);
    this.setActiveViewType(viewInfo.viewType);
    this.setActiveElementId(viewInfo.elementId);
    this.setActiveViewHasOfflineData(false);
    this.setActiveViewOptions(viewInfo.options);
    this.setActiveViewHasSharingInfo(viewInfo.hasSharingInfo ? true : false);
  }

  setViewTitle(viewTitle) {
    this.setActiveViewCaption(viewTitle);
  }

  setMainHeaderVisibility(visible) {
    this.activeMainHeaderIsVisible = visible;
  }

  setViewBackgroundImage(view, url) {
    this.setLocalStoreValue(view + "-backgroundImage", url);
  }

  getViewBackgroundImage(view, defaultImageUrl) {
    let imageUrl = this.getLocalStoreValue(view + "-backgroundImage");
    if (!imageUrl) imageUrl = defaultImageUrl;
    return imageUrl;
  }

  setViewBackgroundColor(view, color) {
    this.setLocalStoreValue(view + "-backgroundColor", color);
  }

  getViewBackgroundColor(view, defaultColor) {
    return this.getLocalStoreValue(view + "-backgroundColor") || defaultColor;
  }

  setViewVisibleElements(view, visibleElements) {
    this.setLocalStoreValue(view + "-visibleElements", visibleElements);
  }

  getViewVisibleElements(view, defaultElements) {
    return (
      this.getLocalStoreValue(view + "-visibleElements") || defaultElements
    );
  }

  setCardViewType(cardname, viewType) {
    this.setLocalStoreValue(cardname + "-viewType", viewType);
  }

  getCardViewType(viewname, defaultState = "list") {
    let viewType = this.getLocalStoreValue(
      viewname + "-viewType",
      defaultState,
    );
    return viewType;
  }

  getCardVisibleState(cardname, defaultState) {
    let isVisible = this.getLocalStoreValue(
      cardname + "-visible",
      defaultState && true,
    );
    return isVisible;
  }

  setCardVisibleState(cardname, isVisible) {
    this.setLocalStoreValue(cardname + "-visible", isVisible);
  }

  getTourAlreadySeenState(tourName) {
    let alreadySeen = this.getLocalStoreValue(
      "tour-" + tourName + "-alreadyseen",
      false,
    );
    return alreadySeen;
  }

  setTourAlreadySeenState(tourName, hasSeen) {
    this.setLocalStoreValue("tour-" + tourName + "-alreadyseen", hasSeen);
    // track
    this.withTracking &&
      track("tour-seen", {
        tourName: tourName,
      });
  }

  setIsLoaded(loaded) {
    this.isLoaded = loaded;
  }

  setIsInitialized(initialized) {
    this.isInitialized = initialized;
  }

  setPaymentAreaVisible(visible) {
    this.isPaymentAreaVisible = visible;
  }

  setChangeTitleAreaVisible(visible) {
    this.isChangeTitleAreaVisible = visible;
  }

  setActiveChangeTitle(value) {
    this.activeChangeTitle = value;
  }

  setFilesAreaVisible(visible) {
    this.isFilesAreaVisible = visible;
  }

  setS3CustomerConfig(hash) {
    this.s3CustomerConfig = hash;
  }

  setOneDriveRetries(value) {
    this.onedrivePickerRetries = value;
  }

  setMagicAuthAreaVisible(value) {
    this.isMagicAuthAreaVisible = value;
  }
}
